export { default } from './ColorSolutions';
